// Footer layout data — follows the same pattern as heroLayouts.constants.js.
//
// Corrected ground truth (re-verified, not assumed): mainFooter.tsx is
// entirely commented out in meelz-client-v2's real layout.tsx
// (`{/* <MainFooter /> */}`) — it has NEVER been live. The only footer that
// actually renders today, for all three brands, is a thin legal bar:
//   - MEELZ: siteLegalFooterContent.tsx — live, real copyright text
//     "© {year} GWT. All rights reserved." (left) + Terms of Service /
//     Privacy Policy links (right), on a dark bg (--color-bottom-bar
//     #1C1C1C), white text.
//   - E4F / CK: confirmed via direct repo read — NEITHER has any footer at
//     all today, not even a legal bar (page ends right after the checkout
//     bar, no <footer> tag anywhere). Since there's nothing live to extract,
//     their layouts are authored to match MEELZ's real legal-bar shape
//     (same minimal content: copyright + terms/privacy links only), using
//     each brand's own real color palette (per hero's already-extracted
//     values) — net-new UI, not a misrepresentation of something live.
//
// `copyrightText`/`termsText`/`privacyText` are authored as {en: "..."}
// from the start — translatable per Step 3.

export const FOOTER_LAYOUT_MEELZ_DEFAULT_PROPS = {
    bgColor:       "#1C1C1C",
    textColor:     "#ffffff",
    copyrightText: { en: "© {year} All rights reserved." },
    termsText:     { en: "Terms of Service" },
    privacyText:   { en: "Privacy Policy" },
};

// E4F: no footer exists live today — authored to match MEELZ's real legal
// bar shape, using E4F's own real palette (#b11212, per hero's already-
// extracted value).
export const FOOTER_LAYOUT_E4F_DEFAULT_PROPS = {
    bgColor:       "#b11212",
    textColor:     "#ffffff",
    copyrightText: { en: "© {year} All rights reserved." },
    termsText:     { en: "Terms of Service" },
    privacyText:   { en: "Privacy Policy" },
};

// CK: no footer exists live today — authored to match MEELZ's real legal
// bar shape, using CK's own real palette (#46298A, per hero's already-
// extracted value).
export const FOOTER_LAYOUT_CK_DEFAULT_PROPS = {
    bgColor:       "#46298A",
    textColor:     "#ffffff",
    copyrightText: { en: "© {year} All rights reserved." },
    termsText:     { en: "Terms of Service" },
    privacyText:   { en: "Privacy Policy" },
};

export const FOOTER_LAYOUTS = {
    meelz: { label: "Layout 1", defaultProps: FOOTER_LAYOUT_MEELZ_DEFAULT_PROPS },
    e4f:   { label: "Layout 2", defaultProps: FOOTER_LAYOUT_E4F_DEFAULT_PROPS },
    ck:    { label: "Layout 3", defaultProps: FOOTER_LAYOUT_CK_DEFAULT_PROPS },
};

// Shared shape — a thin legal bar only, matching what's actually live
// (MEELZ) or authored to match it (E4F/CK). `{year}` inside copyrightText is
// a literal token the client-side StructuralFooter substitutes with the
// current year at render time (mirrors siteLegalFooterContent.tsx's own
// `t("copyright", { year })` interpolation) — not resolved by this admin
// dashboard's preview, which shows the literal token as authored.
export const FOOTER_SCHEMA = [
    { key: "bgColor",       label: "Background color", type: "color" },
    { key: "textColor",     label: "Text color",       type: "color" },
    { key: "copyrightText", label: "Copyright text",   type: "text", translatable: true, wrapControl: true },
    { key: "termsText",     label: "Terms link text",  type: "text", translatable: true, wrapControl: true },
    { key: "privacyText",   label: "Privacy link text", type: "text", translatable: true, wrapControl: true },
];
